import { Button, Icon } from 'ui';

type P = {
  onChange?: (active: boolean) => void;
  value?: boolean;
};

export const PinnedPostToggle = ({ onChange, value }: P) => (
  <Button
    data-test-id="toggle_pin-post"
    icon={value ? <Icon icon="pin-2-fill" /> : <Icon icon="pin-line" />}
    onClick={() => {
      onChange?.(!value);
    }}
    type={value ? 'link-primary' : 'link-secondary'}
  >
    {value ? 'Post pinned' : 'Pin post'}
  </Button>
);
